import moment from 'moment'
import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'
import isEmpty from 'lodash/isEmpty'

const convertValueFor = ['ordering']

export function parseQueryParams(str) {
  if (str.length <= 2) {
    return {} // '' || '?'
  }

  return str
    .substr(1) // symbol '?'
    .split('&')
    .reduce(function(params, param) {
      var paramSplit = param.split('=').map(function(chunk) {
        return decodeURIComponent(chunk.replace('+', '%20'))
      })
      const name = camelCaseParam(paramSplit[0])
      let value = paramSplit[1]
      if (convertValueFor.includes(name)) {
        value = camelCaseParam(value)
      }
      params[name] = Object.prototype.hasOwnProperty.call(params, name) ? [].concat(params[name], value) : value
      return params
    }, {})
}

export function buildQueryParams(params) {
  if (isEmpty(params)) {
    return ''
  }

  return Object.keys(params).reduce(function(ret, key) {
    let value = params[key]

    if (value === null || value === undefined) {
      return ret
    }

    if (!Array.isArray(value)) {
      value = [value]
    }

    value.forEach(function(val) {
      if (String(val).length > 0) {
        const _key = snakeCaseParam(key)
        if (convertValueFor.includes(_key)) {
          val = snakeCaseParam(val)
        }

        ret.push(
          encodeURIComponent(_key) +
          '=' +
          encodeURIComponent(val)
        )
      }
    })
    // TODO null should not be here, check field components

    return ret
  }, []).join('&')
}

export function camelCaseParam(name) {
  const parts = name.split('__')
  name = camelCase(parts.shift())

  if (parts.length === 0) {
    return name
  }

  return `${name}[${parts.join('][')}]`
}

export function snakeCaseParam(name) {
  const parts = name.split('[')
  name = snakeCase(parts.shift())

  if (parts.length === 0) {
    return name
  }

  return `${name}__${parts.join('__').replace(/\]/g, '')}`
}

function orderingEnhancer(func) {
  return function(name) {
    let prefix = ''

    if (/^-\w/.test(name)) {
      prefix = '-'
      name = name.substr(1)
    }

    return prefix + func(name)
  }
}

export const buildReportQueryParams = (
  selectedExport,
  timeRange,
  dateType,
  customStartDate,
  customEndDate
) => {
  let query_params = `report_type=${selectedExport}`
  const time_zone = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)
  query_params += `&time_zone=${time_zone}`
  if (dateType) { query_params += `&date_type=${dateType}` }
  let start, end
  switch (timeRange) {
    case 'week':
      start = moment().subtract(7, 'd').format('YYYY-MM-DD')
      end = moment().format('YYYY-MM-DD')
      break
    case 'month':
      start = moment().subtract(30, 'days').format('YYYY-MM-DD')
      end = moment().format('YYYY-MM-DD')
      break
    case '3months':
      start = moment().subtract(90, 'days').format('YYYY-MM-DD')
      end = moment().format('YYYY-MM-DD')
      break
    case '6months':
      start = moment().subtract(120, 'days').format('YYYY-MM-DD')
      end = moment().format('YYYY-MM-DD')
      break
    case 'customDateRange':
      start = customStartDate.format('YYYY-MM-DD')
      end = customEndDate.format('YYYY-MM-DD')
      break
  }
  if (start && end) {
    query_params += `&start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
  }
  return query_params
}

camelCaseParam = orderingEnhancer(camelCaseParam) // eslint-disable-line no-func-assign
snakeCaseParam = orderingEnhancer(snakeCaseParam) // eslint-disable-line no-func-assign
